import http from "@/http/aisea/axios";
const resource = "/enterprises/owners/manning_vessels/timesheet/records";

export default {
  fetchRecords(params) {
    return http.get(`${resource}`, {
      params: params,
    });
  },
};
